import { useEffect } from 'react';
import { message } from 'antd';

import { useVerifyCode as useVerifyCodeApi } from '../../../hooks/api/claimBusiness';
import { getMessageInError } from '../../../hooks/fetch';

const useVerifyCode = (id: string) => {
  const {
    fetch: verifyCode, response, error, loading,
  } = useVerifyCodeApi(id);

  useEffect(() => {
    if (response?.data.secretKey) {
      message.success('Phone verified successfully');
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      message.error(getMessageInError(error));
    }
  }, [error]);

  return {
    verifyCode,
    response,
    error,
    loading,
  };
};

export default useVerifyCode;
